import React from 'react';
import Input from '../../../../components/forms/Input';
import TimezoneSelect from '../TimezoneSelect';
import PictureHeader from '../PictureHeader';
import KeyValueInputGroup from '../../../../components/forms/KeyValueInputGroup';
import { socialMediaOptions } from '../../../../selectors/admin/models/contacts';
import SelectField from '../../../../components/forms/SelectField';
import TextArea from '../../../../components/forms/TextArea';
import AddressFields from '../AddressFields';
import { PARTNER_CATEGORIES } from '../../../../constants/admin/settings';
import { eventsFromOrganizations } from '../../../../selectors/events/events';

const PartnerInputs = props => (
    <React.Fragment>
        <PictureHeader
            imageField="image"
            nameLabel="Media Partner Name *"
            data={props.data}
            errors={props.errors}
            onInput={props.onInput}
        />
        <div className="ckp-admin-forms-body">
            <div className="ckp-admin-grid-row">
                <div className="ckp-admin-grid-column">
                    <SelectField
                        disabled={props.withContext}
                        items={props.contextOptions}
                        label="Organizations"
                        onChange={props.onInput}
                        name="organizationIds"
                        value={props.withContext ? [props.context] : props.data.organizationIds}
                        multiple={true}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <SelectField
                        disabled={props.withContext ? false : !props.data.organizationIds.length}
                        items={eventsFromOrganizations(
                            props.withContext,
                            props.context,
                            props.data.organizationIds,
                            props.dependencies.events
                        )}
                        label="Events"
                        onChange={props.onInput}
                        name="eventIds"
                        multiple={true}
                        value={props.data.eventIds}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <SelectField
                        withSearch={false}
                        items={PARTNER_CATEGORIES}
                        label="Category *"
                        onChange={props.onInput}
                        name="category"
                        value={props.data.category}
                    />
                </div>
                <div className="ckp-admin-grid-column">
                    <TimezoneSelect label="Partner Timezone *" value={props.data.timeZone} onChange={props.onInput} />
                </div>
            </div>
            <AddressFields errors={props.errors} data={props.data} onInput={props.onInput} />
            <div className="ckp-admin-grid-row">
                <div className="ckp-admin-grid-column is-1-3">
                    {
                        <KeyValueInputGroup
                            name="socialMedia"
                            keyLabel="Social Media"
                            valueLabel="URL"
                            onKeyValueInput={props.onKeyValueInput}
                            options={socialMediaOptions}
                            group={props.data.socialMedia}
                            onDelete={props.onKeyValueDelete}
                        />
                    }
                    <Input
                        className="is-full-width"
                        errorMessage={props.errors.website}
                        label="Website"
                        name="website"
                        onChange={props.onInput}
                        value={props.data.website}
                    />
                </div>
                <div className="ckp-admin-grid-column is-2-3">
                    <TextArea
                        label="Description"
                        className="is-small"
                        name="description"
                        onChange={props.onInput}
                        value={props.data.description}
                    />
                </div>
            </div>
        </div>
    </React.Fragment>
);

export default PartnerInputs;
